







































import { Component, Prop, Vue } from 'vue-property-decorator';
import PreCollectionItem from '@/main-components/pre-collections-new/PreCollectionItem.vue';
import PreCollectionLoading from '@/components/pre-collections/PreCollectionLoading.vue';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { CustomAxiosResponse, axios } from '@/utils/axios';
import { objectKeyCamelToSnakeCase } from '@/utils/common/snake-case-converter';

@Component({
  components: {
    PreCollectionItem,
    PreCollectionLoading,
  },
})
export default class PreCollectionCustomList extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  @Prop({ required: true })
  preCollectionsQueries!: PreCollectionsParams;

  @Prop({ required: true })
  title: string;

  @Prop({ default: false })
  isListOnly: boolean;

  isLoading = true;

  preCollections: PreCollection[] = [];

  async created() {
    await this.fetchPreCollections();

    this.isLoading = false;
  }

  async fetchPreCollections() {
    const convertedParams = objectKeyCamelToSnakeCase(
      this.preCollectionsQueries,
    );

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `/pre-collections`,
        {
          params: {
            ...convertedParams,
            page: 1,
            limit: this.isListOnly ? 10 : 4,
          },
        },
      );

      return (this.preCollections = data);
    } catch (error) {
      console.log(error);
    }
  }
  redirectToBrowse() {
    Object.keys(this.preCollectionsQueries).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(this.queries, key)) {
        this.queries[key] = this.preCollectionsQueries[key];
      }
    });

    this.$sendMpEvent({
      event: this.$mp_value.HomeViewAll,
      properties: {
        title: this.title,
      },
    });

    this.$emit('reFetch');
  }
}
